import '../universal-auth/cognito/cognito.helper.js';
import 'aws-amplify/utils';
import 'zustand/react/shallow';
import '../universal-auth/auth.store.js';
import 'react';
import { getAuthToken } from '../universal-auth/auth.helpers.js';

const authInterceptor = async (config)=>{
    const token = await getAuthToken();
    if (token) {
        /**@ts-ignore */ config.headers['Authorization'] = await getAuthToken();
    }
    return config;
};

export { authInterceptor as default };
//# sourceMappingURL=authInterceptor.js.map
